import { useState } from "react";
import Cross from "../../assets/icons/Cross";
import { showSnackbar, updateMiscState } from "../../misc/utils";
import { accessGlobalMiscState, useGlobalMiscState } from "../../stores/misc";
import { DisciplinaryCase } from "../../types";
import InputField from "../input-field/InputField";
import DefaultButton from "../default-button/DefaultButton";
import ArrowLeft from "../../assets/icons/ArrowLeft";
import { simpleGetter } from "../../actions/common";
import { demeritsApi } from "../../api/api";

export const RejectDisciplinaryCase = () => {
    const miscState = useGlobalMiscState();
    const disciplinaryCasesDemeritCurrentCase: DisciplinaryCase = miscState.get('disciplinaryCasesDemeritCurrentCase') || {}
    const [input, changeInput] = useState("");

    const onClose = () => {
        miscState.set('disciplinaryCasesRejectCaseModalOpen', false)
    }

    const onReject = async () => {
        const response = await simpleGetter(demeritsApi.rejectDisciplinaryCase, { id: disciplinaryCasesDemeritCurrentCase.id, comment: input });
        showSnackbar(
            response.success ? "Успешно" : "Произошла ошибка",
            response.success ? "success" : "error"
        );
        if (response.success) {
            accessGlobalMiscState().setBatch({
                disciplinaryCasesTriggerFetch: (accessGlobalMiscState().get("disciplinaryCasesTriggerFetch") || 0) + 1,
                disciplinaryCasesRejectCaseModalOpen: false
            })
        }
    }

    return (
        <div className="flex flex-col flex-1">
            <div>
                <p className="font-normal text-[15px] text-[#5F6B88]">
                    Отклонить нарушение
                </p>
                <p className="text-black font-normal text-[24px]">
                    {disciplinaryCasesDemeritCurrentCase.name}
                </p>
            </div>
            <div className="flex-grow mt-8">
                <p className="font-medium text-[15px] text-[#5F6B88]">Комментарий*</p>
                <InputField
                    type="textarea"
                    value={input}
                    handleChange={(e) => changeInput(e.target.value)}
                    additionalClassName="bg-[#F0F3FA] w-full resize-none outline-none rounded-lg px-4 py-3 mt-2"
                />
            </div>
            <div className="grid grid-cols-[5fr_7fr] gap-3 mt-4">
                <DefaultButton
                    buttonText="Вернуться"
                    additionalStyle="bg-[#5F6B88] text-white px-8 py-3 text-nowrap"
                    Icon={ArrowLeft}
                    onClick={onClose}
                />
                <DefaultButton
                    buttonText="Отклонить дело"
                    additionalStyle="bg-[#F12D2D] text-white px-8 py-3 text-nowrap"
                    Icon={Cross}
                    onClick={onReject}
                />
            </div>
        </div>
    );
}